import { useRef } from "react";

import { FieldLabel } from "../../styles/common.styles";
import { VariablesFieldContainer } from "./StatusMessageField.styles";
import { variables } from "../../../../constants/variables";

import Skeleton from "@mui/material/Skeleton";
import TextField from "@mui/material/TextField";

import { SmsEditor } from "@autoserve/woosent.woosent.sms-editor";


interface Props {
	settings: Record<string, string | boolean | string[]>;
	setSettings: React.Dispatch<
		React.SetStateAction<Record<string, string | boolean | string[]>>
	>;
	fieldLabel: string;
	statusSlug: string;
	isDefaultMessage?: boolean;
}

const StatusMessageField = ({
	settings,
	setSettings,
	fieldLabel,
	statusSlug,
	isDefaultMessage = false,
}: Props) => {
	const inputRef = useRef<HTMLTextAreaElement>(null);

	const handleAddEmoji = (emoji: string) => {
		setSettings({
			...settings,
			[statusSlug]: settings[statusSlug] + emoji,
		});
	};

	const handleConcatInputValue = (concatVal: string) => {
		const selectionStart = inputRef.current?.selectionStart;
		const selectionEnd = inputRef.current?.selectionEnd;

		const value = settings[statusSlug] as string;
		const newValue =
			value.substring(0, selectionStart) +
			concatVal +
			value.substring(selectionEnd as number, value.length);

		setSettings({
			...settings,
			[statusSlug]: newValue,
		});
	};

	if (!isDefaultMessage) {
		return (
			<>
				<FieldLabel variant='subtitle2'>{fieldLabel + " Message"}</FieldLabel>
				<VariablesFieldContainer>
					<SmsEditor
						value={(settings[statusSlug] as string) || ""}
						handleInputChange={(e) => {
							setSettings({
								...settings,
								[statusSlug]: e.target.value,
							});
						}}
						variables={variables}
						handleAddEmoji={handleAddEmoji}
						handleConcatInputValue={handleConcatInputValue}
						enableInsertImage={false}
						enableUrlShortener={false}
						sendable={false}
						fullWidth={true}
						ref={inputRef}
					/>
				</VariablesFieldContainer>
			</>
		);
	}

	return (
		<>
			<FieldLabel variant='subtitle2'>{fieldLabel}</FieldLabel>
			<VariablesFieldContainer>
				{settings[statusSlug] === undefined ||
				(settings[statusSlug] as string).length < 0 ? (
					<Skeleton variant='rectangular' width='100%'>
						<TextField multiline minRows={2} />
					</Skeleton>
				) : (
					<SmsEditor
						value={(settings[statusSlug] as string) || ""}
						handleInputChange={(e) => {
							setSettings({
								...settings,
								[statusSlug]: e.target.value,
							});
						}}
						variables={variables}
						handleAddEmoji={handleAddEmoji}
						handleConcatInputValue={handleConcatInputValue}
						enableInsertImage={false}
						enableUrlShortener={false}
						sendable={false}
						fullWidth={true}
						ref={inputRef}
					/>
				)}
			</VariablesFieldContainer>
		</>
	);
};

export default StatusMessageField;
